export default __webpack_public_path__ + "static/media/paper_graphqa_2020.8902dd4e.png";